import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { registerEnsoTranslations } from '@ohpen/enso-ui';
import { CONFIG_NAMESPACE, registerConfigTranslations } from '@config';

// The portal's own literals load from /locales/{{lng}}/translation.json; Enso's and the
// configuration module's resolve from their own namespaces.
const ready = i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    fallbackNS: ['enso', CONFIG_NAMESPACE],
    interpolation: {
      escapeValue: false,
    },
  });

registerEnsoTranslations(i18n);
registerConfigTranslations(i18n);

export default ready;
